import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'
import Subheader from 'material-ui-legacy/Subheader'

import { niceCount } from '../../lib/formats.js'
import { getWindowHeight } from '../../lib/util.js'
import errors from '../../lib/errors.js'
import LinearLoader from '../UI/LinearLoader'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'
import ErrorDialog from '../UI/ErrorDialog'

import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

class ServiceCategoryCard extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      services: [],
      error: '',
      loading: true
    }

    // Data can be received either as serviceCategory or itemData.
    this.serviceCategory = this.props.serviceCategory || this.props.itemData
  }

  componentWillMount() {
    ServiceStore.findAll({ serviceCategoryId: this.serviceCategory.id })
      .then(result => this.setState({ services: result.data, loading: false }))
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const {
      editCallback,
      deleteCallback,
      closeCallback,
      noHeightAdjust
    } = this.props

    const { loading, error, services } = this.state

    const {
      projectTypeName,
      name,
      serviceCount
    } = this.serviceCategory.attributes

    const cardStyle = noHeightAdjust
      ? {}
      : {
          overflowY: 'auto',
          minHeight: '300px',
          maxHeight: `${getWindowHeight() - 210}px`
        }

    return (
      <Card style={cardStyle}>
        <CardTitle
          title={`${projectTypeName}: ${name}`}
          subtitle={niceCount(serviceCount, 'service', 'services')}
        />
        {Boolean(serviceCount) && (
          <CardText>
            <Subheader>Related services:</Subheader>
            {loading && <LinearLoader />}
            <ul>
              {services.map(service => (
                <li key={service.id}>
                  <Link to={`/services/${service.id}`}>
                    {service.attributes.name}
                  </Link>
                </li>
              ))}
            </ul>
          </CardText>
        )}

        <CardActions>
          {editCallback && <EditButton onTouchTap={editCallback} />}
          {deleteCallback && (
            <DeleteButton
              onTouchTap={deleteCallback}
              confirmMessage={
                <p>
                  Are you sure you want to delete <strong>{name}</strong>?
                  There's no undo.
                </p>
              }
            />
          )}
          {closeCallback && <CloseButton onTouchTap={closeCallback} />}
        </CardActions>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </Card>
    )
  }
}

export default ServiceCategoryCard



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ServiceCategoryCard.jsx